<template>
    <div :id="pair">
        <trading-vue
            ref="chart"
            :id="pair"
            type="candles"
            :width="width"
            :height="height"
            color-back="#ffffff"
            color-grid="#eee"
            color-text="#333"
            :timezone="timezone"
            :titleTxt="pair"
            :overlays="overlays"
            :data="chart_data"
            :toolbar="false"
            :chart-config="{
                DEFAULT_LEN: 1000,
            }"
        ></trading-vue>
    </div>
</template>
<script>
import {TradingVue, DataCube} from "trading-vue-js";
import helperMethods from "@/helpers";
import TrendOverlay from "@/Charts/Overlays/TrendOverlay.vue";

export default {
    props:{
        width: Number,
        height: Number,
        pair: String,
        candles: Array|undefined,
        deals: Array|undefined,
        indicators: Array|undefined,
        zeroPrice: String,
        timezone: Number,
        numCandlesOnScreen: Number,
        useBand: String,

        candlesChartData: Array,
        dealsChartData: Array,
    },
    components:{
        TradingVue
    },
    data(){
        return {
            overlays: [TrendOverlay]
        }
    },
    mounted(){
        // console.log(this.dealsToChartData(this.deals, this.zeroPrice))
    },
    computed:{
        chart_data(){
            let candlesData;
            let dealsData;
            if(this.candlesChartData) candlesData = this.candlesChartData;
            else candlesData = this.ohlcvFromCandles(this.candles, this.zeroPrice);
            if(this.dealsChartData) dealsData = this.dealsChartData;
            else dealsData = this.dealsToChartData(this.deals, this.zeroPrice);
            return new DataCube({
                ohlcv: candlesData,
                onchart: this.onchart_data
            });
        },
        onchart_data(){
            let data = [
                {
                    name: "Deals",
                    type: "Trades",
                    data: this.dealsToChartData(this.deals, this.zeroPrice),
                },
            ];
            // data.push({
            //     name: "Slowtrend",
            //     type: "Trend",
            //     data: this.indicators.map((item) => {
            //         let color = "gray"
            //         if(item.slowtrend_value === "up") color = "green";
            //         if(item.slowtrend_value === "down") color = "red";
            //         return [parseInt(item.date), this.priceToPercent(parseFloat(item.slowtrend_average), this.zeroPrice), color]
            //     }),
            //     "settings":{
            //         lineWidth: 2,
            //         colorRed: "#f8a6bf",
            //         colorGreen: "#99eab0",
            //     }
            // });
            data.push({
                name: "upperBuy",
                type: "Trend",
                data: this.indicators.map((item) => {
                    let color = "gray"
                    if(item.allowShortByWidth) color = "green";
                    return [parseInt(item.date), this.priceToPercent(parseFloat(item.upperBuy), this.zeroPrice), color]
                }),
                settings:{
                    lineWidth: 1,
                }
            });
            data.push({
                name: "lowerBuy",
                type: "Trend",
                data: this.indicators.map((item) => {
                    let color = "gray"
                    if(item.allowLongByWidth) color = "green";
                    return [parseInt(item.date), this.priceToPercent(parseFloat(item.lowerBuy), this.zeroPrice), color]
                }),
                settings:{
                    lineWidth: 1,
                }
            });
            data.push({
                name: "upperSell",
                type: "Spline",
                data: this.indicators.map((item) => {
                    // let color = "blue"
                    return [parseInt(item.date), this.priceToPercent(parseFloat(item.upperSell), this.zeroPrice)]
                }),
                settings:{
                    lineWidth: 0.7,
                    color: '#c9d9ea'
                }
            });
            data.push({
                name: "lowerSell",
                type: "Spline",
                data: this.indicators.map((item) => {
                    // let color = "blue"
                    return [parseInt(item.date), this.priceToPercent(parseFloat(item.lowerSell), this.zeroPrice)]
                }),
                settings:{
                    lineWidth: 0.7,
                    color: '#c9d9ea'
                }
            });
            data.push({
                name: "fastJma",
                type: "Spline",
                data: this.indicators.map((item) => {
                    return [parseInt(item.date), this.priceToPercent(parseFloat(item.fastJma), this.zeroPrice)]
                }),
                settings: {
                    lineWidth: 0.7,
                    color: '#c5c5c5'
                }
            });
            data.push({
                name: "jma",
                type: "Spline",
                data: this.indicators.map((item) => {
                    return [parseInt(item.date), this.priceToPercent(parseFloat(item.jma), this.zeroPrice)]
                }),
                settings: {
                    lineWidth: 1,
                    color: '#b9b9b9'
                }
            });
            return data;
        }
    },
    methods:{
        ...helperMethods,
    }

}
</script>
